/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class FaceConfigurationOffSpringDto {
    organisationId: string | null;
    orderId: string | null;
    configurationTemplateId: string | null;
    faceConfigurationId: string;
    isOrganisationAddable: boolean;
    isUserSelectable: boolean;
    belongsToUser: boolean;
}
